import React from "react";
import "./Totals.css";
import { useStateValue } from "./StateProvider";
//import { players, holes } from "./CourseInfo";

function Totals({ id }) {
  //  const [{ hole }] = useStateValue();
  const [{ scores }] = useStateValue();
  const [{ overs }] = useStateValue();
  const [{ netovers }] = useStateValue();

  //calculates every player when score changed....can optimize*********************************
  const getTotal = (scoresarray) => {
    const Total = scoresarray?.reduce(
      (totalStrokes, score) => totalStrokes + score.strokes,
      0
    );
    return Total;
  };
 
  const getFrontTotal = (id) => {
    const frontNine = scores.filter((s) => s.id === id && s.hole < 10);
    return frontNine;
  };
  const getFrontOver = (id) => {
    const frontNine = overs.filter((s) => s.id === id && s.hole < 10);
    return frontNine;
  };
  const getFrontNetOver = (id) => {
    const frontNine = netovers.filter((s) => s.id === id && s.hole < 10);
    return frontNine;
  };

  const getBackTotal = (id) => {
    const backNine = scores.filter((s) => s.id === id && s.hole > 9);
    return backNine;
  };
  const getBackOver = (id) => {
    const backNine = overs.filter((s) => s.id === id && s.hole >9);
    return backNine;
  };
  const getBackNetOver = (id) => {
    const backNine = netovers.filter((s) => s.id === id && s.hole >9);
    return backNine;
  };

  const getTotal18 = (id) => {
    const allHoles = scores.filter((s) => s.id === id && s.hole);
    return allHoles;
  };
  const getTotalOver = (id) => {
    const allOver = overs.filter((s) => s.id === id);
    return allOver;
  };
  const getTotalNetOver = (id) => {
    const allNetOver = netovers.filter((s) => s.id === id);
    return allNetOver;
  };

  return (
    <div className="totals">
      <div className="totals__score">
        <table>
          <thead>
            <tr>
              <th>FRONT</th>
              <th>BACK</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{getTotal(getFrontTotal(id))}</td>
              <td>{getTotal(getBackTotal(id))}</td>
              <td>{getTotal(getTotal18(id))}</td>
            </tr>
            <tr>
            <td>{getTotal(getFrontOver(id))+ "/" + getTotal(getFrontNetOver(id))}</td>
              <td>{getTotal(getBackOver(id))+ "/" + getTotal(getBackNetOver(id))}</td>
              <td>{getTotal(getTotalOver(id))+ "/" + getTotal(getTotalNetOver(id))}</td>

            </tr>
          </tbody>
          </table> 


         
      </div>
    </div>
  );
}

export default Totals;
